import { useSelector } from "react-redux";
import { homeStateSelector } from "@store/redux/modules/home";
import RainProb from "@assets/icons/Rain_Prob.svg?react";
import { pxChangeVw } from "@/utils";
import { dailyRoute, homeRoute } from "@/router";
import { speakText } from "../Hour";
import useDayjs from "@/hooks/useDayjs";
import useDateFormat from "@/hooks/useDateFormat";
import { useTranslation } from "react-i18next";
const { dayjs, userTimeZone } = useDayjs();

export const getWeekName = (EpochDateTime: number) => {
  const dayOfWeek = dayjs.unix(EpochDateTime).tz(userTimeZone).day();
  const { t: $t } = useTranslation();
  return [$t("title25"), $t("title26"), $t("title27"), $t("title28"), $t("title29"), $t("title30"), $t("title31")][
    dayOfWeek
  ];
};
const RecentWeather: React.FC = () => {
  try {
    const { t: $t } = useTranslation();
    const { forecast5day = [] } = useSelector(homeStateSelector);
    const navigate = useNavigate();
    const handleClick = (e: any) => {
      e.preventDefault();
      navigate(dailyRoute.path);
    };
    const { pathname } = useLocation();
    const { shortDate } = useDateFormat();
    const handleSpeakClick = () => {
      const weatherDetails = forecast5day
        .map((item: any) => {
          const date = item?.EpochDateTime
            ? userTimeZone
              ? dayjs.unix(item.EpochDateTime).tz(userTimeZone).format(shortDate)
              : item.DateShort
            : "";
          const weatherText =
            item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]?.WeatherText ||
            "";
          const precipitationProbability =
            item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]
              ?.PrecipitationProbability || "";
          const temperatureRange = `${item?.Temperature?.Minimum?.Value} to ${item?.Temperature?.Maximum?.Value} degrees Celsius`;

          return `On ${date}, ${weatherText}. Precipitation Probability: ${precipitationProbability}%. Temperature Range: ${temperatureRange}.`;
        })
        .join(". ");

      const text = `${$t("title01")}. ${weatherDetails}`;
      speakText(text);
    };

    return (
      <WeatherMainContent className="content" onClick={handleSpeakClick}>
        {forecast5day.map((item: any, index: number) => {
          const weekDayName = getWeekName(item.EpochDateTime);
          return (
            <div
              key={index}
              className="w-full flex justify-between items-center gap-x-10 p-[15px_0] border-b-1 border-solid border-b-[rgba(255,255,255,0.3)] last:border-none"
            >
              <div className="text-center w-15%">
                <p className="font-500">{weekDayName ?? item.Week}</p>
                <p className="font-400 text-12">
                  {item?.EpochDateTime &&
                    (userTimeZone ? dayjs.unix(item.EpochDateTime).tz(userTimeZone).format(shortDate) : item.DateShort)}
                </p>
              </div>
              <div className="w-25 center">
                <WeatherImage
                  className="w-full block mt-3"
                  src={
                    item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]
                      ?.WeatherIconImg
                  }
                />
              </div>
              {/* <div className="Weather_text">{item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]?.WeatherText}</div> */}
              <div className="font-400 text-12 w-120">
                {item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]?.WeatherText}
              </div>
              <div className="flex justify-end items-center gap-x-5 flex-1">
                <span style={{ display: "flex", columnGap: pxChangeVw("5px"), alignItems: "center" }}>
                  <RainProb
                    style={{
                      width: pxChangeVw("12px"),
                    }}
                  />
                  {
                    item?.[pathname === homeRoute.path ? "Day" : item?.isDayTime * 1 === 1 ? "Day" : "Night"]
                      ?.PrecipitationProbability
                  }
                  %
                </span>
                <span>
                  {item?.Temperature?.Maximum?.Value}
                  {item?.Temperature?.Maximum?.Unit}/{item?.Temperature?.Minimum?.Value}
                  {item?.Temperature?.Minimum?.Unit}
                </span>
              </div>
            </div>
          );
        })}
        <a
          onClick={handleClick}
          rel="noreferrer"
          className="block m-[15px_auto_5px_auto] w-80% bg-[rgba(255,255,255,0.1)] text-center h-30 lh-30 rounded-10 color-[#fff] decoration-none font-400 text-12"
        >
          {$t("title03")}
        </a>
      </WeatherMainContent>
    );
  } catch (error) {}
};
export default RecentWeather;
